export const visit = (vm, at) => {
at({ "da": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "Har du problemer med at se denne video?", "playButton": "Afspil" } } });
};